var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "pt-20 pb-20" },
    [
      _c("div", { staticClass: "success-content" }, [
        _c("div", { staticClass: "success-icon" }),
        _vm._v(" "),
        _vm.boleto
          ? _c("h2", [_vm._v("SEU BOLETO ESTÁ PRONTO!")])
          : _c("h2", [_vm._v("SUA LIMPEZA FOI AGENDADA COM SUCESSO!")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v("Leia todas instruções abaixo!")
      ]),
      _vm._v(" "),
      _vm.showBoletoWarning
        ? _c("div", { staticClass: "boleto-warning" }, [
            _c("h4", [_vm._v("VOCÊ PRECISA ENVIAR O COMPROVANTE")]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n      Para que a limpeza não seja cancelada,\n      "),
              _c(
                "b",
                { staticClass: "pointer", on: { click: _vm.openFreshdesk } },
                [_vm._v("clique aqui")]
              ),
              _vm._v(
                " e envie o comprovante de pagamento com até 48h úteis antes da limpeza.\n    "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.boleto ? _c("boleto", { attrs: { boleto: _vm.boleto } }) : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttons" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn bg-pink",
              attrs: {
                to: {
                  name: _vm.singularPayableType(),
                  params: { id: _vm.payable.id }
                }
              }
            },
            [_vm._v(_vm._s(_vm.buttonText()))]
          ),
          _vm._v(" "),
          _vm._m(0)
        ],
        1
      ),
      _vm._v(" "),
      _vm.payable.type === "orders"
        ? _c("p", [
            _vm._v(
              "\n    O profissional acaba de ser notificado sobre esta nova limpeza. O seu pagamento ficará retido no\n    Wirecard e só será enviado ao profissional após a limpeza. Caso o profissional cancele, você pode solicitar o reagendamento ou o reembolso.\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("FAQ", {
        attrs: {
          rules: _vm.payable.type === "orders",
          city: _vm.payable.address.district.city
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "btn bg-green wpp",
        attrs: {
          href:
            "https://api.whatsapp.com/send?text=Acabei%20de%20contratar%20uma%20diarista%20para%20fazer%20faxina%20pela%20plataforma%20Donamaid.%20Os%20profissionais%20s%C3%A3o%20avaliados%2C%20t%C3%AAm%20refer%C3%AAncia%20e%20levam%20os%20produtos%20de%20limpeza%21%20Use%20o%20cupom%20de%20desconto%20XHJD453%20para%20sua%20pr%C3%B3xima%20faxina%21%20www.donamaid.com",
          target: "_blank",
          rel: "noopener noreferrer"
        }
      },
      [
        _vm._v("\n      Envie descontos para amigos\n      "),
        _c("img", {
          staticClass: "ml-10",
          attrs: { src: "\\static\\whatsapp_logo.svg" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-951f4a56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-951f4a56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Success.vue
// module id = null
// module chunks = 